import axios, { AxiosInstance, CancelToken } from 'axios';
import get from 'lodash/get';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { DailyCapacityPerWeek } from 'utils/types/dailyTeamsCapacity';

export interface FetchDailyTeamMembersCapacityApiResponse {
  userId: string;
  defaultCapacity: string;
  dailyCapacities: {
    weeks: DailyCapacityPerWeek;
  };
  links: {
    prevDay: string;
    nextDay: string;
  };
}

class TeamMembersCapacityAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(config.get('backendURL'), 'resourcing');
  }

  fetchDailyTeamMembersCapacity: (
    url: string,
    cancelToken?: CancelToken
  ) => Promise<FetchDailyTeamMembersCapacityApiResponse> = async (
    url,
    cancelToken
  ) => {
    const response =
      await this.instance.get<FetchDailyTeamMembersCapacityApiResponse>(url, {
        cancelToken,
      });
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const teamMembersCapacityAPI = new TeamMembersCapacityAPI();
export default teamMembersCapacityAPI;
